import { Component, Input } from '@angular/core';
import { User } from '@app/core/models';
import { UsersService } from '@app/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-eula-modal',
  template: `
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title flex-fill text-center" id="headerLabel">Terms and Conditions</h4>
      </div>
      <div class="modal-body">
        <div style="max-height: 450px; overflow-y: auto;">
          <p [innerHtml]="eulaText"></p>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <button type="button" ngbAutofocus class="btn btn-primary btn-min-width" (click)="acceptEula()">I Agree</button>
      </div>
    </div>
  `
})

export class EulaModalComponent {

  @Input()
  eulaText: string;

  @Input()
  user: User;

  constructor(
    public activeModal: NgbActiveModal,
    private usersService: UsersService
  ) { }

  acceptEula(): void {
    this.usersService.acceptEula(this.user)
      .then((response) => {
        if (response.eulaAcceptedTime != null) {
          this.activeModal.close();
        }
      })
      .catch(() => {

      });
  }
}
